// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"348":"chat","410":"redeem","483":"widget-config","489":"jnto","550":"ops","755":"kiosk"}[chunkId] || chunkId) + "." + {"348":"8fd81795","410":"727d86be","413":"8ae986fb","483":"a03834d1","489":"6e55a7bb","550":"6d4e19e3","560":"f39ad277","755":"6fecb5c1","793":"8ca3f58b"}[chunkId] + ".chunk.css";
};